module.exports = __webpack_public_path__ + "static/media/tips-background.c32a4266.svg";